import React, { useState } from 'react'
import { Form } from "react-bootstrap"
import { isDecimalValue } from '../../../common/Helpers';
import CValidator from '../CValidator';

function CTextBox(props) {

    //Parametros de entrada.
    const inputParam_LabelText = props.labelText;
    const inputParam_TextBoxName = props.textBoxName;
    const inputParam_ClassName = props.className !== null && props.className !== undefined ? props.className : "";
    const inputParam_ControlValue = props.controlValue;
    const inputParam_SetterControlValue = props.setterControlValue; 
    const inputParam_IsInvalidControl = props.isInValid !== null && props.isInValid !== undefined ? props.isInValid : null;
    const inputParam_IsInvalidText = props.isInvalidText !== null && props.isInvalidText !== undefined ? props.isInvalidText : null;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
    const inputParam_OnlyNumbers = props.onlyNumbers !== null && props.onlyNumbers !== undefined ? props.onlyNumbers : false;
    const inputParam_MaxLength = props.maxLength !== null && props.maxLength !== undefined ? props.maxLength : null;
    const inputParam_OnlyNumbersCustomEvent = props.onlyNumbersCustomEvent !== null && props.onlyNumbersCustomEvent !== undefined ? props.onlyNumbersCustomEvent : undefined;
    const inputParam_TextBoxStyle = props.style !== null && props.style !== undefined ? props.style : undefined;
    const inputParam_OnKeyDown = props.onKeyDown !== null && props.onKeyDown !== undefined ? props.onKeyDown : undefined;

    
    //Parametros posibles a obtener como parametros de entrada.
    const inputParam_PlaceHolder = "";
    const inputParam_AutoComplete = "off";

    //Parametros de componente.
    const [isInvalidControl, setIsInvalidControl] = useState(false);

    //Funciones de componente.
    const isInValidFormControl = (value) => {
        return value === "" ? true : false;
    }

    const checkIfIsInvalidControl = () => {
        const _isInvalidControl = isInvalidControl !== null ? isInvalidControl : false;
        const _inputParam_IsInvalirControl = inputParam_IsInvalidControl !== null ? inputParam_IsInvalidControl : false;

        return _isInvalidControl === true | _inputParam_IsInvalirControl === true ? true : false;
    }

    //Eventos de componente.
    const onChangeValue = (e) => {
        let valueIsOk = inputParam_OnlyNumbers ? false : true;
        if (inputParam_OnlyNumbers) {
            if (inputParam_OnlyNumbersCustomEvent !== undefined) {
                valueIsOk = inputParam_OnlyNumbersCustomEvent(e.target.value)
            }
            else {
                valueIsOk = isDecimalValue(e.target.value)
            }
        }

        if (valueIsOk) {
            let controlValue = e.target.value;

            if (inputParam_IsInvalidControl !== null) {
                setIsInvalidControl(isInValidFormControl(controlValue));
            }
            
            inputParam_SetterControlValue(controlValue, inputParam_TextBoxName);
        }
    };

    //Render de componente.
    return (
        <>
            {
                inputParam_LabelText &&
                <b><Form.Label>{ inputParam_LabelText }</Form.Label></b>
            }
            <Form.Control
                type="text"
                className={"form-control form-control-sm " + inputParam_ClassName}
                name={ inputParam_TextBoxName }
                id={ inputParam_TextBoxName ? inputParam_TextBoxName : undefined }
                value={ (inputParam_ControlValue ? inputParam_ControlValue : undefined) || '' }
                onChange={ onChangeValue }
                maxLength={inputParam_MaxLength !== null ? inputParam_MaxLength : undefined}
                isInvalid={ inputParam_IsInvalidControl !== null ? checkIfIsInvalidControl() : false }
                placeholder={ inputParam_PlaceHolder }
                autoComplete={ inputParam_AutoComplete }
                disabled={!inputParam_EditMode}
                style={inputParam_TextBoxStyle}
                onKeyDown={inputParam_OnKeyDown}
            />
            <CValidator isInValid={ checkIfIsInvalidControl() } isInValidText={ inputParam_IsInvalidText } />
        </>
    );
}

export default CTextBox;